import ErrorBox from '@components/common/ErrorBox';
import ExchangeInBoutique from '@components/exchange/ExchangeInBoutique';
import Button from '@ui/button/Button';
import DwFormField from '@ui/formfield/DwFormField';
import analytics from '@utils/analytics';
import api from '@utils/api';
import formutils from '@utils/formutils';
import React, { useEffect, useState } from 'react';
import { Form } from 'react-final-form';
import { useTranslation } from 'react-i18next';
import { Tab, TabList, TabPanel, Tabs } from 'react-tabs';
import Section from '@common/components/common/Section';
import ReturnInBoutique from '@common/components/returns/ReturnInBoutique';
import { addURLParameter } from '@common/utils/urlutils';
import customEventBus from '@common/scripts/libs/eventBus';
const ReturnsGuestForm = (props) => {
    const { t } = useTranslation();
    const [formdef, setFormdef] = useState();
    const [initialValues, setInitialValues] = useState();
    const [errorMessage, setErrorMessage] = useState();
    useEffect(() => {
        let val = {};
        api.getForm('returns', val).then((data) => {
            setFormdef(data);
            setInitialValues(val);
        });
    }, []);
    useEffect(() => {
        if (props.activeTabs !== 'Both') {
            customEventBus.emit('csform::tabchange', { tab: props.activeTabs.toLowerCase() });
        }
        else {
            customEventBus.emit('csform::tabchange', { tab: 'virtual' });
        }
    }, [props.activeTabs]);
    const validate = async (values) => {
        return await formutils.validateForm(values, formdef, 'returns');
    };
    const onSubmit = async (values) => {
        let errors = await validate(values);
        if (errors && Object.keys(errors).length > 0) {
            return errors;
        }
        api.openReturn(values.orderNumber, values.email, props.isExchange).then((result) => {
            if (!result.success) {
                setErrorMessage([result.errorMessage]);
                return;
            }
            props.isExchange ? analytics.exchangeStepOne('proceed') : analytics.returnsStepOne('proceed');
            let newUrl = addURLParameter(props.openreturnurl, 'orderId', values.orderNumber);
            window.location.href = addURLParameter(newUrl, 'token', result.token);
        });
    };
    const renderFirstSection = () => (React.createElement(Section, { introSection: true, title: t(props.isExchange ? 'exchanges.title' : 'returns.title'), description: t('returns.description') },
        React.createElement(Form, { initialValues: initialValues, onSubmit: onSubmit, validate: validate, render: ({ handleSubmit, form, submitting, pristine, values }) => (React.createElement("form", { onSubmit: handleSubmit },
                React.createElement(DwFormField, { def: formdef, name: "orderNumber", autocomplete: "orderNumber", validTick: true }),
                React.createElement(DwFormField, { def: formdef, name: "email", autocomplete: "email", validTick: true }),
                React.createElement("div", { className: "client-service__column-wrapper" },
                    !window.appmode && !props.loggedUser && (React.createElement("a", { href: window.loginUrl, className: "button button--secondary", onClick: () => {
                            // props.isExchange ? analytics.exchangeStepOne('login') : analytics.returnsStepOne('login');
                            analytics.clientServiceRedesignAnalytics(`${props.pagetitleforanalytics}`.toLowerCase(), t('returns.tabonlineanalytics') + '-' + t('button.loginanalytics').toLowerCase());
                        } },
                        React.createElement("span", null, t('button.login')))),
                    React.createElement(Button, { type: "submit", disabled: submitting, onClick: () => {
                            analytics.clientServiceRedesignAnalytics(`${props.pagetitleforanalytics}`.toLowerCase(), t('returns.tabonlineanalytics') + '-' + t('button.proceedanalytics').toLowerCase());
                        } }, t('button.proceed'))),
                React.createElement(ErrorBox, { errors: errorMessage, className: "mt-20" }))) })));
    return (React.createElement(React.Fragment, null, !props.activeTabs || props.activeTabs == 'Both' ? (React.createElement(Tabs, { className: "tabs tabs--fluid tabs--capitalize tabs--centered container--neg" },
        React.createElement(TabList, { className: "react-tabs__tab-list client-service__tablist container" },
            React.createElement(Tab, { onClick: () => {
                    analytics.clientServiceRedesignAnalytics(`${props.pagetitleforanalytics}`.toLowerCase(), t('returns.tabonlineanalytics').toLowerCase());
                    customEventBus.emit('csform::tabchange', { tab: 'virtual' });
                } }, t('returns.tabonline')),
            !window.faf && !window.appmode && !window.isClothing && (React.createElement(Tab, { onClick: () => {
                    analytics.clientServiceRedesignAnalytics(`${props.pagetitleforanalytics}`.toLowerCase(), t('returns.tabboutiqueanalytics').toLowerCase());
                    customEventBus.emit('csform::tabchange', { tab: 'physical' });
                } }, t('returns.tabboutique')))),
        React.createElement("div", { className: "container" },
            React.createElement(TabPanel, null, formdef && renderFirstSection()),
            !window.faf && React.createElement(TabPanel, null, props.isExchange ? React.createElement(ExchangeInBoutique, Object.assign({}, props)) : React.createElement(ReturnInBoutique, Object.assign({}, props)))))) : props.activeTabs == 'Virtual' ? (React.createElement(React.Fragment, null,
        React.createElement("h2", { className: "tabs-single-tab-title" }, t('returns.tabonline')),
        formdef && renderFirstSection())) : props.activeTabs == 'Physical' ? (React.createElement(React.Fragment, null,
        React.createElement("h2", { className: "tabs-single-tab-title" }, t('returns.tabboutique')),
        !window.faf && (props.isExchange ? React.createElement(ExchangeInBoutique, Object.assign({}, props)) : React.createElement(ReturnInBoutique, Object.assign({}, props))))) : null));
};
export default ReturnsGuestForm;
